import { render, staticRenderFns } from "./Bangbangshougou.vue?vue&type=template&id=768640c3&scoped=true&"
import script from "./Bangbangshougou.vue?vue&type=script&lang=js&"
export * from "./Bangbangshougou.vue?vue&type=script&lang=js&"
import style0 from "./Bangbangshougou.vue?vue&type=style&index=0&id=768640c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768640c3",
  null
  
)

export default component.exports